var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { computed } from "mobx";
import { observable, observe, action } from "mobx";
import { mapHasLiveEvents, mapHasLiveStreaming, mapLeagueUrl, sortLeagues, filterLeagues, mapSelected, mapRequiredProps } from "../composable";
import { InternalMessageBusChannels, internalMessageBus } from "sb-internal-msg-bus";
import Debounce from "debounce-decorator";
import { updateLeagueRankID } from "../helpers";
var Parser = /** @class */ (function () {
    function Parser(retriever, config, navigationHandler) {
        this.retriever = retriever;
        this.leagues = [];
        this.selectedLeagues = [];
        this.navigationHandler = navigationHandler;
        this.config = config;
        this.isLoading = false;
        //this.mapLeagueLinkUrl = mapLeagueUrl.bind(this, navigationHandler.Navigation.adjustPath);
        this.onLogin = this.onLogin.bind(this);
        this.globalListeners = {};
        this.globalListeners[InternalMessageBusChannels.legacy.platformJWTChange.renewJWTToken] = "renewJWTToken";
        this.globalListeners[InternalMessageBusChannels.legacy.userInfo.onLogin] = "onLogin";
        this.globalListeners[InternalMessageBusChannels.legacy.userInfo.onLogout] = "onLogout";
        this.leaguesDisposer = function () { };
        this.sportId = "1";
        this.regionIds = [config.regionId];
        this.sortIPTopLeaguesFirst = config.sortIPTopLeaguesFirst;
    }
    Parser.prototype.attachMsgBusRouter = function () {
        var _this = this;
        Object.keys(this.globalListeners).forEach(function (x) { return internalMessageBus.on(x, _this.msgRouterGlobal, _this); });
    };
    Parser.prototype.detachMsgBusRouter = function () {
        var _this = this;
        Object.keys(this.globalListeners).forEach(function (x) { return internalMessageBus.off(x, _this.msgRouterGlobal, _this); });
    };
    Parser.prototype.msgRouterGlobal = function (msg) {
        this[this.globalListeners[msg.channel + "." + msg.subChannel.join(".")]].apply(this, __spread(msg.data));
    };
    Parser.prototype.requestGlobalListeners = function () {
        internalMessageBus.emit(InternalMessageBusChannels.legacy.userInfo.request, { callback: this.onLogin });
    };
    Parser.prototype.attachObservables = function () {
        var _this = this;
        this.leaguesDisposer = observe(this.retriever, function (change) {
            _this.updateLeagues();
        });
    };
    Parser.prototype.onLogin = function (user) {
        if (user) {
            this.retriever.setRegionId(user.CountryOfRegistration);
            this.regionIds = [this.config.regionId, user.CountryOfRegistration];
        }
    };
    Parser.prototype.onLogout = function () {
        this.retriever.removeRegionId();
        this.regionIds = [this.config.regionId];
    };
    Parser.prototype.renewJWTToken = function () {
        this.retriever.leaguesRetriever && this.retriever.leaguesRetriever.loadData();
    };
    Parser.prototype.detachObservables = function () {
        this.leaguesDisposer();
    };
    Parser.prototype.activate = function () {
        this.retriever.activate();
        this.attachObservables();
        this.attachMsgBusRouter();
        this.requestGlobalListeners();
    };
    Parser.prototype.selectRetriever = function (sportId, leagueIds) {
        this.clearData();
        this.sportId = sportId;
        this.retriever.selectRetriever(sportId, leagueIds);
    };
    Parser.prototype.deactivate = function () {
        this.detachObservables();
        this.detachMsgBusRouter();
        this.clearData();
        this.retriever.deactivate();
    };
    Parser.prototype.updateLeagues = function () {
        var _this = this;
        var leagues = this.retriever.leagues.slice();
        var regions = this.regionIds;
        if (this.sortIPTopLeaguesFirst) {
            leagues = leagues.map(function (league) {
                var isFromRegion = regions && league.regionId && regions.indexOf(league.regionId) >= 0;
                isFromRegion && updateLeagueRankID(league, isFromRegion);
                return league;
            });
        }
        leagues = filterLeagues(leagues, this.sportId);
        leagues = sortLeagues(leagues, this.config, this.sportId);
        leagues = mapSelected(leagues, this.selectedLeagues);
        this.leagues = leagues.map(function (league) {
            mapRequiredProps(league);
            mapHasLiveEvents(league);
            mapHasLiveStreaming(league);
            mapLeagueUrl(_this.navigationHandler.Navigation.adjustPath, league);
            return league;
        });
    };
    Parser.prototype.clearData = function () {
        this.leagues = [];
        this.selectedLeagues = [];
    };
    Parser.prototype.toggleSelectedLeague = function (leagueId) {
        if (this.selectedLeagues.length >= this.config.maxCouponLeagues && this.selectedLeagues.indexOf(leagueId) === -1) {
            return false;
        }
        else {
            this.updateSelectedLeagues(leagueId);
            this.toggleIsSelectedLeagues(leagueId);
            return true;
        }
    };
    Parser.prototype.updateSelectedLeagues = function (leagueId) {
        var selLeagues = this.selectedLeagues.slice();
        var selectedIndex = selLeagues.indexOf(leagueId);
        selectedIndex > -1 ? selLeagues.splice(selectedIndex, 1) : selLeagues.push(leagueId);
        this.selectedLeagues = selLeagues;
    };
    Parser.prototype.toggleIsSelectedLeagues = function (leagueId) {
        var leagues = this.leagues.slice();
        var leagueIndex = this.leagues.findIndex(function (league) { return league.id === leagueId; });
        if (leagueIndex > -1) {
            leagues[leagueIndex].isSelected = !leagues[leagueIndex].isSelected;
        }
        this.leagues = leagues;
    };
    Object.defineProperty(Parser.prototype, "getTopLeaguesOnly", {
        get: function () {
            var _this = this;
            return this.leagues.filter(function (league) { return league.isTopLeague
                || _this.regionIds.indexOf(league.regionId || "") >= 0; });
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], Parser.prototype, "leagues", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], Parser.prototype, "selectedLeagues", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], Parser.prototype, "isLoading", void 0);
    __decorate([
        Debounce,
        __metadata("design:type", Object)
    ], Parser.prototype, 100, void 0);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "updateLeagues", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "clearData", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "updateSelectedLeagues", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], Parser.prototype, "toggleIsSelectedLeagues", null);
    __decorate([
        computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], Parser.prototype, "getTopLeaguesOnly", null);
    return Parser;
}());
export { Parser };
//# sourceMappingURL=Parser.js.map